module.exports = __webpack_public_path__ + "static/media/OLED灯屏模块.52cac00c.png";